// extracted by css-extract-rspack-plugin
export default {"cls1":"SocialProofFadeFooter-cls1_6Ld","cls2":"SocialProofFadeFooter-cls2__lz SocialProofFadeFooter-cls1_6Ld"};